import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MutasiAntarCounterPage } from './mutasi-antar-counter.page';

const routes: Routes = [
  {
    path: '',
    component: MutasiAntarCounterPage
  },
  {
    path: 'mutasi-antar-counter-form',
    loadChildren: () => import('./mutasi-antar-counter-form/mutasi-antar-counter-form.module').then( m => m.MutasiAntarCounterFormPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MutasiAntarCounterPageRoutingModule {}
